import { render, staticRenderFns } from "./waterBillReport.vue?vue&type=template&id=2f88e8c1&scoped=true&"
import script from "./waterBillReport.vue?vue&type=script&lang=js&"
export * from "./waterBillReport.vue?vue&type=script&lang=js&"
import style0 from "./waterBillReport.vue?vue&type=style&index=0&id=2f88e8c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88e8c1",
  null
  
)

export default component.exports